import { render, staticRenderFns } from "./UpdateContractRoles.vue?vue&type=template&id=718dcf20&scoped=true&"
import script from "./UpdateContractRoles.vue?vue&type=script&lang=js&"
export * from "./UpdateContractRoles.vue?vue&type=script&lang=js&"
import style0 from "./UpdateContractRoles.vue?vue&type=style&index=0&id=718dcf20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718dcf20",
  null
  
)

component.options.__file = "UpdateContractRoles.vue"
export default component.exports